import { FC } from 'react';
import { ModelliStat } from './useModelliWaStatus';
import { ModelliStatCard } from './ModelliStatCard';

export const ModelliStatsRow: FC<{ stats: ModelliStat[] }> = ({ stats }) => (
  <div className='grid grid-cols-2 gap-3 sm:grid-cols-4'>
    {stats.map((stat) => (
      <ModelliStatCard key={stat.label} label={stat.label} value={stat.value} />
    ))}
  </div>
);
